<sub-header [isModal]="true" [windowHash]=windowHash [includeContextHelp]="true"></sub-header>
<p-scrollPanel [style]="{width: '100%', height: '80vh'}" styleClass="custombar1">
  <div class="container-fluid " *ngIf="isLoaded()">
    <div class="row">
      <div class="col-12">
        <p-panel [toggleable]="true" [collapsed]="false">
          <p-header>
            <span> <i class="fa fa-file" aria-hidden="true"></i> {{'General.filters'|translate}}</span>
          </p-header>
          <div class="col-12 ">
            <formPlyca #formPlycaRef1 [formConfig]="formConfig1" *ngIf="formConfig1" [manageWaitService]=false>
            </formPlyca>
          </div>
          <div class=" col-12 text-right"> <button class="btn btn-sm btn-secondary" (click)="this.clearFilter()"
              title="{{ 'General.reset.filters' | translate}}">
              <i class="fas fa-undo" aria-hidden="true"></i> <span> {{ 'General.reset.filters' | translate}}</span>
            </button>
            <button class="btn btn-sm btn-primary ml-2" (click)="this.loadData()"
              title="{{ 'General.search.text' | translate}}">
              <i class="fas fa-search" aria-hidden="true"></i> <span> {{ 'General.search.text' | translate}}</span>
            </button>
          </div>
        </p-panel>
      </div>
    </div>
    <div class="row m-t-md ">
      <div class="col-12 ">
        <p-panel [toggleable]="true" [collapsed]="false">
          <p-header>
            <span class="label label-default float-right" style="font-size: small;font-weight: 500;">{{ 'Tasks.showing'
              | translate }} {{elements ? elements.length : '0'}} </span>
          </p-header>
          <div class="row  ">
            <div class="col-12 ">
              <div class="alert alert-info col-12" role="alert" *ngIf="!elements || elements.length===0">
                <span style="line-height: 2em;"><i class="fa fa-1-5x fa-info-circle mr-2" aria-hidden="true"></i>{{
                  'General.noData' | translate }}</span>
              </div>
              <p-table *ngIf="elements && elements.length>0" [value]="elements" sortOrder="1" [rows]="10"
                [paginator]="true" [pageLinks]="4" [rowsPerPageOptions]="[5, 10, 25, 50]" class="footer-over-pagination"
                [scrollable]="false" responsiveLayout="scroll">
                <ng-template pTemplate="header">
                  <tr>
                    <th pSortableColumn="requestedMaterial.lot.lotNumber" *ngIf="this.showLotes" class="TEXTTH-w100">
                      {{'ProcurementProject.breakdownLot.lots.lotNumber'|translate}} <p-sortIcon
                        field="requestedMaterial.lot.lotNumber)">
                      </p-sortIcon>
                    </th>
                    <th pSortableColumn="requestedMaterial.referenceCode" class="TEXTTH-w100 th-wrap ">
                      {{'RequestedMaterial.ReferenceCode'|translate}} <p-sortIcon
                        field="requestedMaterial.referenceCode">
                      </p-sortIcon>
                    </th>
                    <th pSortableColumn="requestedMaterial.description" class="TEXTTH-w200   th-wrap ">
                      {{'General.description'|translate}} <p-sortIcon field="requestedMaterial.description">
                      </p-sortIcon>
                    </th>
                    <th pSortableColumn="requestedMaterial.amount" class="CURRENCYTH  th-wrap ">
                      {{'RequestedMaterial.units'|translate}} <p-sortIcon field="requestedMaterial.amount">
                      </p-sortIcon>
                    </th>
                    <th pSortableColumn="requestedMaterial.unitMeasurement" class="TEXTTH-w100 th-wrap ">
                      {{'ProcurementProject.requestedMaterial.unitMeasurement'|translate}} <p-sortIcon
                        field="requestedMaterial.unitMeasurement">
                      </p-sortIcon>
                    </th>
                    <th class="text-right" pSortableColumn="requestedMaterial.unitPrice" class="CURRENCYTH th-wrap ">
                      {{'RequestedMaterial.UnitPrice'|translate}} <p-sortIcon field="requestedMaterial.unitPrice">
                      </p-sortIcon>
                    </th>
                    <th pSortableColumn="tenderRequestedMaterial.supplierReference" class="TEXTTH-w100  th-wrap ">
                      {{'RequestedMaterial.tender.supplierReference'|translate}} <p-sortIcon
                        field="tenderRequestedMaterial.supplierReference">
                      </p-sortIcon>
                    </th>
                    <th pSortableColumn="tenderRequestedMaterial.description" class="TEXTTH-w200   th-wrap ">
                      {{'RequestedMaterial.tender.description'|translate}} <p-sortIcon field="description">
                      </p-sortIcon>
                    </th>
                    <th *ngIf="element?.tenderRequestedMaterial!==undefined" class="CURRENCYTH  th-wrap "
                      pSortableColumn="tenderRequestedMaterial.unitPrice">
                      {{'RequestedMaterial.tender.unitPrice'|translate}} <p-sortIcon
                        field="tenderRequestedMaterial.unitPrice">
                      </p-sortIcon>
                    </th>
                    <th class="CURRENCYTH  th-wrap " pSortableColumn="unitPrice">
                      {{'RequestedMaterial.award.unitPrice'|translate}} <p-sortIcon field="unitPrice">
                      </p-sortIcon>
                    </th>
                    <th class="text-right action-column-2"> &nbsp; </th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-element>
                  <tr>
                    <td *ngIf="this.showLotes" class="TEXTTH-w100">
                      <formatDataValue [type]="'TEXT'" [value]="'#'+element.requestedMaterial.lot?.lotNumber">
                      </formatDataValue>
                    </td>
                    <td class="TEXTTH-w100">
                      <formatDataValue [type]="'TEXT'" [value]="element.requestedMaterial.referenceCode">
                      </formatDataValue>
                    </td>
                    <td class="TEXTTH-w200 ">
                      <formatDataValue [type]="'TEXT'" [value]="element.requestedMaterial.description">
                      </formatDataValue>
                    </td>
                    <td class="CURRENCYTH">
                      <formatDataValue [type]="'INTEGER'" [value]="element.requestedMaterial.amount"></formatDataValue>
                    </td>
                    <td class="TEXTTH-w100">
                      <formatDataValue [type]="'TEXT'" [value]="element.requestedMaterial.unitMeasurement">
                      </formatDataValue>
                    </td>
                    <td class="CURRENCYTH">
                      <formatDataValue [type]="'CURRENCY'" [value]="element.requestedMaterial.unitPrice">
                      </formatDataValue>
                    </td>
                    <td *ngIf="element?.tenderRequestedMaterial!==undefined" lass="TEXTTH-w100 ">
                      <formatDataValue [type]="'TEXT'"
                        [value]="element?.tenderRequestedMaterial?.supplierReference?element.tenderRequestedMaterial.supplierReference:'--'">
                      </formatDataValue>
                    </td>
                    <td class="TEXTTH-w200 ">
                      <formatDataValue [type]="'TEXT'"
                        [value]="element?.tenderRequestedMaterial?.description?element.tenderRequestedMaterial.description:'--'">
                      </formatDataValue>
                    </td>
                    <td *ngIf="element?.tenderRequestedMaterial!==undefined" class="CURRENCYTH">
                      <formatDataValue [type]="'CURRENCY'" [value]="element.tenderRequestedMaterial.unitPrice">
                      </formatDataValue>
                    </td>
                    <td class="CURRENCYTH">
                      <formatDataValue [type]="'CURRENCY'" [value]="element.unitPrice"></formatDataValue>
                    </td>
                    <td class="text-right action-column-2">
                      <div class="float-right btn-group d-flex justify-content-end text-right">
                        <button class="btn btn-sm btn-secondary t-action-button" (click)="this.removeRow(element)"
                          title="{{ 'General.delete' | translate}}">
                          <i class="fas fa-times" aria-hidden="true"></i>
                        </button>
                        <button class="btn btn-sm btn-secondary t-action-button" (click)="this.openEditor(element)"
                          title="{{ 'General.edit' | translate}}">
                          <i class="fas fa-pencil-alt" aria-hidden="true"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </p-panel>
      </div>
    </div>
  </div>
</p-scrollPanel>